import React, { useState } from "react";
import BuilderModal from "../../../Layouts/Modal/BuilderModal";
import TableTreeModal from "../../../components/BuilderComponents/TableTreeModal";
import ChipList from "../../../components/BuilderComponents/ChipList";
import ButtonActionIcon from "../../../components/BuilderComponents/ButtonActionIcon";
import Label from "../../../components/FormComponents/Label";
import { toastError } from "../../../utils/toastUtils";

const SelectSubfields = ({ label, value, onChange, tableId, tableType }) => {
  const [isOpen, setIsOpen] = useState(false);
  const callbackFunction = (data) => {
    const safeValue = Array.isArray(value) ? value : [];

    const existingField = safeValue.find((field) => field.id === data.id);
    if (existingField) {
      toastError("Field already exists");
      return;
    }

    const updatedFields = [...safeValue, data];
    onChange(updatedFields);
  };

  const removeField = (_, index) => {
    const updatedFields = [...value];
    updatedFields.splice(index, 1);
    onChange(updatedFields);
  };

  if (!tableId) return;

  return (
    <>
      <div className="flex_row justify_between">
        <Label className="builder_label" style={{ marginBottom: "0px" }}>
          {label}
        </Label>
        {tableId ? (
          <ButtonActionIcon type="add" size="xsm" onClick={() => setIsOpen(true)} />
        ) : (
          <div>Required Table</div>
        )}
      </div>
      <div style={{ display: "flex" }}>
        <div className="selected_chip_container" style={{ marginTop: "12px" }}>
          {value && value.length > 0 && <ChipList chips={value} labelKey={"display"} removeChip={removeField} />}
        </div>
      </div>
      <BuilderModal isOpen={isOpen} onClose={() => setIsOpen(false)} modalName="Add Field">
        <TableTreeModal
          callbackFunction={callbackFunction}
          tableType={tableType}
          tableId={tableId ? tableId : "appuser"}
        />
      </BuilderModal>
    </>
  );
};

export default SelectSubfields;
